import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title"];
import React from 'react';
import EasyTooltip from 'components/EasyTooltip';
import Pill from 'components/Pill';
export function TooltipPill(props) {
  var title = props.title,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(EasyTooltip, {
    content: title
  }, /*#__PURE__*/React.createElement(Pill, _extends({}, otherProps, {
    "aria-label": title
  })));
}
export default TooltipPill;